import { z } from 'zod'

/** Equality of these three fields identifies an artifact, including same-commit rebuilds. */
export const appBuildSchema = z.object({
  release: z.string().trim().min(1).max(128).refine(value => !/^(dev|unknown)$/i.test(value)),
  // Staging emits an abbreviated commit, with -dirty for local builds.
  gitSha: z.string().regex(/^[a-f0-9]{7,40}(?:-dirty)?$/i),
  builtAt: z.iso.datetime({ offset: true }),
})
export type AppBuild = z.infer<typeof appBuildSchema>
